/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Canvas.module.css';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
class Canvas extends Component {
  // after component is rendered
  componentDidMount = () => {
    this.updateCanvas();
  };

  componentDidUpdate() {
    this.updateCanvas();
    this.draw();
  }

  updateCanvas() {
    let canvas = this.refs.canvas;

    this.size = {};
    this.ctx = canvas.getContext('2d');

    // this.size.width = canvas.offsetWidth;
    // this.size.height = canvas.offsetHeight;
    this.size = this.props.size;

    canvas.width = this.size.width;
    canvas.height = this.size.height;
  }

  draw = () => {
    // this.ctx.clearRect(0, 0, 100, 100);
    // let imageData = this.ctx.getImageData(0, 0, this.width, this.height);

    if (!this.props.image) {
      let imageData = this.ctx.createImageData(
        this.size.width,
        this.size.height
      );
      // console.log(imageData.data.length);

      // this.changeToGreen(imageData.data);
      this.props.matrix.forEach((el, idx) => (imageData.data[idx] = el));

      // Update the canvas with the new data
      this.ctx.putImageData(imageData, 0, 0);
    } else {
      let img = new Image();
      img.src = this.props.src;

      let imgData;
      img.onload = () => {
        this.ctx.drawImage(img, 0, 0);
        imgData = this.ctx.getImageData(0, 0, img.width, img.height);
        // immediately clear, since will be repositioned
        this.ctx.clearRect(0, 0, img.width, img.height);
        this.props.onImgLoad(imgData.data, img.width, img.height);
      };
    }
  };

  render() {
    return (
      // 10x10 are actual canvas pixels
      // we change it above to the real box widthxheight
      // if width is not defined here (any value, even it is updated later),
      //  there is somehow a problem with layout
      <div>
        <div className={styles.heading}>{this.props.title}</div>
        <canvas ref="canvas" width="10" height="10" className={styles.frame} />
      </div>
    );
  }
}

export default Canvas;
